import {
    PaymentElement,
    LinkAuthenticationElement,
  } from "@stripe/react-stripe-js";
  import { useContext, useEffect, useRef, useState } from "react";
  import { useStripe, useElements, CustomCheckoutProvider } from "@stripe/react-stripe-js";
  import styled from "styled-components";
  import { useTranslation } from "react-i18next";
  import { CartContext } from "../../../context/CartContext";
  import { Actions_, AlertContext, Alert_, Builder_, Card, Checkbox_, Dropdown_, Focus_, Form, Grey_, Input_, Input_Phone_Register, Main_ ,  Main_Loader, Main_Text_Loader, PhoneContext, device} from "monica-alexandria";
  import { create_confirm_payment_intent, create_confirm_subscription, create_customer_v2, get_latest_questad_payment_method, one_step_susbcription_creation } from "../../../services/api/Subscriptions";
  import store from "../../../redux/store";
  import i18n from "../../../localization/i18next";
  import { useNavigate } from "react-router-dom";
  import { prettifyPrice } from "../../../helpers/prettifyFunctions";
  import { CheckoutExtraInput } from "../../../styles/Layout.css";
  import { countries as jsvatCountries } from 'jsvat';
  import { countries as monicaCountries } from 'monica-alexandria';
import { validatePhone, validatePhoneInternational } from "../../checkoutDetails/utils";
import { isValid } from "date-fns";
import { get_questad_checkout_tracking } from '../../../helpers/questadTracking';
import { syncCheckoutBrandCustomer } from '../../../services/api/Quests';
  
  const clients = require('../../../config/index').config
  
  const PaymentDetails = styled.div`
  `;

  const SavedPaymentMethod = styled(Card)`
    padding: var(--normalPads);
    margin: var(--normalPads) 0;
  `;

  const SavedPaymentMethodDetails = styled.div`
    display: flex;
    flex-direction: column;
    gap: .25rem;

    strong {
      color: var(--greyDark);
      font-family: "fontMedium", sans-serif;
      font-size: 1.6rem;
      line-height: 1.3;
    }

    p {
      margin: 0;
      color: var(--greyDark);
      font-family: "fontLight", sans-serif;
    }
  `;

  const SavedPaymentMethodSelection = styled.span`
    color: var(--success);
    font-family: "fontMedium", sans-serif;
    font-size: 1.4rem;
    font-weight: 600;
    line-height: 1.4;
  `;

  const SavedPaymentMethodActions = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: .5rem;
    margin-top: 1rem;

    @media ${device.md} {
      > * {
        flex: 1;
      }
    }
  `;
  
  
  export default function Payment_Details(props) {
    const stripe = useStripe();
    const elements = useElements();
    const cart  = useContext(CartContext);
    const { t } = useTranslation(); 
    const navigate = useNavigate();
    const { alerts, setAlerts } = useContext(AlertContext);
    const [loading, setLoading] = useState(false);
    const [email, setEmail] =  useState(false)
    const [buttonText, setButtonText] = useState("")
    const [vatInput, setVatInput] = useState();
    const [savedPaymentMethod, setSavedPaymentMethod] = useState(false);
    const [useSavedPaymentMethod, setUseSavedPaymentMethod] = useState(false);
    const [vatWasEdited, setVatWasEdited] = useState(false);
    const appliedInitialVat = useRef("");
  
    useEffect(() => {
      const initialVat = String(props?.initialVat || "").trim();
      if (!initialVat || appliedInitialVat.current === initialVat) return;

      appliedInitialVat.current = initialVat;
      setVatInput(initialVat);
      setVatWasEdited(false);
      props?.setBillingFields({ ...props?.billingFields, vat: initialVat });
    }, [props?.initialVat]);

    useEffect(() => {
      if (!props?.initialVat) return;

      let active = true;
      get_latest_questad_payment_method().then((paymentMethod) => {
        if (!active || !paymentMethod?.id || !paymentMethod?.customerId) return;
        setSavedPaymentMethod(paymentMethod);
        setUseSavedPaymentMethod(true);
      });
      return () => { active = false; };
    }, [props?.initialVat]);
  
    const hasOriginalPrefilledVat = String(vatInput || "").trim() === String(props?.initialVat || "").trim();
    const canReuseSavedPaymentMethod = Boolean(savedPaymentMethod && hasOriginalPrefilledVat && !vatWasEdited);
    const isReusingSavedPaymentMethod = Boolean(canReuseSavedPaymentMethod && useSavedPaymentMethod);

    useEffect(() => {
      if (!canReuseSavedPaymentMethod) setUseSavedPaymentMethod(false);
    }, [canReuseSavedPaymentMethod]);

    const [phoneCode, setPhoneCode] = useState();
    const [currentPhone, setCurrentPhone] = useState(props?.billingFields?.phone || '');
    const user = store.getState().user.user;
  
    //TODO: UPDATE CUSTOMER STORAGE LOGIC
    const currentCart = cart.length>1 ? cart : store.getState().cart
    const category = 'dailyprofit';
    const lang = i18n.language ? i18n.language : "el";
    const quest = store.getState().params.quest;
  
    const chooseRedirectURI = (category, property, checkoutEntryId) => {
      switch (true) {
        case category === 'lois':
          return `${clients['lois']}/${lang}/success-payment`;
        case category === 'bond' && property === "vandador":
          return `${clients['vandador']}/${lang}/more-info?email=${email}&plan=${currentCart[0]?.name}`;
        case category === 'bond' && property === "agency":
          return `${clients['agency']}/${lang}/more-info?email=${email}&plan=${currentCart[0]?.name}`;
        case category === 'dailyprofit':
          return `${clients['dailyprofit']}/${lang}/success-payment?quest=${quest}&checkout_entry_id=${checkoutEntryId}`;
        default:
          return `${clients['griphook']}/${lang}/my-plans`;
      }
    }
  
    const [messages, setMessages] = useState({
      errorsPhone: [],
      helpersPhone: [],
      successesPhone: [],
      errorsVat: [],
      helpersVat: [],
      successesVat: [],
    });
  
  
    const handleCheckboxChange = () => {
      props?.setShowVatInput(prevState => !prevState);
    };
  
    const alertMessage = (message, status) => {
      if (props?.setCheckoutAlert) {
        props.setCheckoutAlert([
          {
            message: {
              text: message,
              status,
            },
          },
        ]);
      }
  
      setAlerts([
          ...alerts,
          {
              message: {
                  text: t("There has been an error"),
                  status: status,
              },
          },
      ]);
      setTimeout(() => {
        setAlerts((prevAlerts) => prevAlerts.slice(1));
      }, 5000);
    };
  
    const validatePhoneFormat = (e) => {
      let formattedPhone = e.target.value.replace(/\s+/g, ''); // Remove any spaces
      let dataPhone = validatePhoneInternational(formattedPhone, t);
      setMessages({
          ...messages,
          helpersPhone: dataPhone.helper,
          successesPhone: dataPhone.success,
          errors:[]
      });
      setCurrentPhone(formattedPhone);
      props.setBillingFields({
          ...props?.billingFields,
          phone: `${phoneCode}${formattedPhone}`
      });
  };
    const validateVat = (vatValue, country) => {
      if (!props?.showVatInput) return { isValid: true };
  
      const rawVat = (vatValue || '').toString();
      const cleanedVat = rawVat.trim();
  
      if (!cleanedVat) return { isValid: false };
  
      props?.setBillingFields({
        ...props?.billingFields,
        vat: cleanedVat,
        address: { country: props?.selectedCountry }
      });
  
      return { isValid: true };
    };
  
  
    const handleError = (error) => {
      setLoading(false);
      alertMessage(t(`${error.message}`), 'Error');
    }
  
  
  
    const createAndConfirmSubscritpion = (customer, cart, trial, email, paymentMethod) =>{
      // const updatedBilling = window.sessionStorage.getItem('billing')
      console.log("TEST")
      let checkoutTracking = get_questad_checkout_tracking() || props?.checkoutTracking;
      create_confirm_subscription(customer, cart, trial, user?.sub, email, paymentMethod, quest, props?.discount, props?.billingFields, props?.total, props?.checkoutEntryId, checkoutTracking)
      .then(res=>{
        console.log("RES SUB", res)
        if (!res || res?.code !== 'QBC-2000') {
          setLoading(false);
          alertMessage(t("Something went wrong with stripe. Check your information and try again, or contact support"), 'Error');
        }
        else {
          setLoading(true);
          handleServerResponse(res?.data, customer)
        } 
      })
  
    }
  
    const handleServerResponse = async (response, customer) => {
      setLoading(true);
      console.log("SERVER RESPONSE", response)
      if (response?.length>0 && response.some(paymentIntent => 
        paymentIntent?.last_payment_error && 
        JSON.stringify(paymentIntent?.last_payment_error) !== "{}"
      )) {
        response.forEach(paymentIntent => {
          alertMessage(t("Something went wrong with stripe. Check your information and try again, or contact support."), 'Error');
        });
        setLoading(false);
      }
  
      else if (response?.status === "requires_action" ) {
        // Use Stripe.js to handle the required next action
        const {
          error,
          paymentIntent,
          setupIntent
        } = await stripe.handleNextAction({
          clientSecret: response?.client_secret
        })
  
        if (error) {
  
          setLoading(false);
          alertMessage(t("We could not verify your payment method. Check your information and try again, or contact support."), 'Error')
          // Show error from Stripe.js in payment form
        }
        else{
          let intent = paymentIntent ? paymentIntent : setupIntent
          createAndConfirmSubscritpion(customer, currentCart, props?.trial, user?.username, intent?.payment_method)
        }
      }
      else if(response?.status === "succeeded") {
        console.log('redirect to success page')
          createAndConfirmSubscritpion(customer, currentCart, props?.trial, user?.username, response?.payment_method)
      }
      else {
        window.location.replace(chooseRedirectURI(category, currentCart[0]?.property, props?.checkoutEntryId))
      }
  
    }
    const checkTin = (vatValue, isUserEdit = true) =>{
      if (isUserEdit) {
        setVatWasEdited(true);
        setUseSavedPaymentMethod(false);
      }
      setVatInput(vatValue)
      let helpers =[], successes=[];
      console.log('vatValue1', vatValue);
  
      if (props?.selectedCountry) {
        const valid_vat = validateVat(vatValue, props?.selectedCountry);
        if (!valid_vat?.isValid) helpers.push(t('TIN is not valid'))
        if (valid_vat?.isValid) successes.push(t('TIN is valid'))
        setMessages({...messages, helpersVat: helpers, successesVat: successes})
        console.log('here',valid_vat);
      } else {
        setMessages({...messages, helpersVat: [], successesVat: [], errorsVat:[]})
  
      }
  
    }
  
  
  
  
    const handleSubmit = async (event) => {
      // We don't want to let default form submission happen here,
      // which would refresh the page.
      event.preventDefault();
  
      if (!stripe || (!isReusingSavedPaymentMethod && !elements)) {
        // Stripe.js hasn't yet loaded.
        // Make sure to disable form submission until Stripe.js has loaded.
        return null;
      }
  
      // Trigger form validation and wallet collection
      let submitError;
      if (!isReusingSavedPaymentMethod) {
        ({error: submitError} = await elements.submit());
        if (submitError) {
          handleError(submitError);
          return;
        }
      }
  
      // The saved card is explicitly selected in this frontend; new cards use Stripe Elements.
      let error;
      let paymentMethod;
      if (isReusingSavedPaymentMethod) {
        paymentMethod = {id: savedPaymentMethod.id};
      } else {
        ({error, paymentMethod} = await stripe.createPaymentMethod({
          elements,
          params:{billing_details: {
            address: {country: props?.selectedCountry, postal_code :"", state:"", city:"", line1:"", line2:""}
            }
          }
        }));
      }
      console.log("paymentMethod", paymentMethod)
  
     console.log(messages);
  
     if (messages?.helpersPhone?.length > 0 || !currentPhone || (props.showVatInput && (messages?.helpersVat?.length > 0 || !vatInput) ) ) {
      // Handle VAT input validation
      console.log('props.showVatInputprops.showVatInput', props.showVatInput);
  
      if (props.showVatInput) {
        console.log('Hi');
  
        if (!vatInput) {
          setMessages((prev) => ({ ...prev, errorsVat: [t('VAT input cannot be empty')],helpersVat: [],successesVat: []}));
        } else if (messages?.helpersVat?.length > 0) {
          setMessages((prev) => ({...prev, errorsVat: prev.helpersVat || [] ,helpersVat: [],successesVat: []}));
          setVatInput('');
        }
  
      }
  
      // Handle phone input validation
      if (!currentPhone) {
        setMessages((prev) => ({...prev,errorsPhone: ['Phone input cannot be empty'],helpersPhone: [],successesPhone: []}));
      } else if (messages?.helpersPhone?.length > 0) {
        setMessages((prev) => ({...prev,errorsPhone: prev.helpersPhone || [], helpersPhone: [], successesPhone: []}));
        setCurrentPhone('');   
    }
  
  
      // Alert message for any error
      alertMessage(t(`Something went wrong. Please check your fields.`), 'Error');
      return;
    }
      else if (error) {
        // This point is only reached if there's an immediate error when
        // creating the PaymentMethod. Show the error to your customer (for example, payment details incomplete)
        handleError(error);
        return;
      }
      // Create the PaymentIntent
      else {
        setLoading(true);
        if (isReusingSavedPaymentMethod) {
          create_confirm_payment_intent(savedPaymentMethod.customerId, currentCart, props?.trial, user?.sub, paymentMethod.id, props?.total, props?.currency)
          .then(intent => {
            if (intent?.code === "SCC4000") {
              setLoading(false);
              alertMessage(t("Your card was declined. Make sure you have enough funds to complete the payment."), "Error");
            } else handleServerResponse(intent?.paymentAction, savedPaymentMethod.customerId);
          })
          .catch(() => setLoading(false));
          return;
        }
        create_customer_v2(props?.billingFields, props?.questId || quest)
        .then(async(res) => {
          if (res?.code !== 'QBC-2000' || !res?.customer) {
            setLoading(false);
            alertMessage(t('Something went wrong. Check your billing information and try again.'), 'Error');
            return;
          }
  
          const brandCustomerSync = await syncCheckoutBrandCustomer({
            questId: props?.questId || quest, customerId: res.customer, customerName: res?.data?.customerName || '', vatNumber: props?.billingFields?.vat || ''
          });
          console.log('[QUESTAD CHECKOUT CUSTOMER]', {
            questId: props?.questId || quest, brandId: brandCustomerSync?.data?.brandId || '', brandName: brandCustomerSync?.data?.brandName || props?.brandAssociation?.brandName || '',
            customerId: res.customer, action: res?.data?.action || '', vatNumber: props?.billingFields?.vat || '', brandCustomerSync
          });
  
          create_confirm_payment_intent(res.customer, currentCart, props?.trial, user?.sub, paymentMethod?.id, props?.total, props?.currency)
          .then(intent => {
            if(intent?.code==='SCC4000') {
              setLoading(false);
              alertMessage(t("Your card was declined. Make sure you have enough funds to complete the payment."), 'Error');
            }
            else handleServerResponse(intent?.paymentAction, res.customer)
          })
          .catch(err => {
            console.log(err);
            setLoading(false);
          });
        })
        .catch(err => {
          console.log(err);
          setLoading(false);
        });
  
  
      // Handle any next actions or errors. See the Handle any next actions step for implementation.
      }
    };
  
  
    useEffect(()=>{
      if(props?.trial) setButtonText(`${t("Try")} ${currentCart[0]?.name}`)
      else setButtonText(`${t("Buy")} Questad`)
    },[props?.trial])
  
  
    useEffect(() => {
      if (vatInput) {
        checkTin(vatInput, false); // This will run checkTin whenever selectedCountry changes
      }
    }, [props?.selectedCountry, vatInput]);
  
  /* TODO: AD LOADER FOR PAGE INIT*/
  
  console.log('billing_details', props?.billingFields);
  
    console.log('MESSAGES', messages);
  
  return (
      <PaymentDetails id="payment-form">
        {loading &&  <Main_Text_Loader text={t('We are proccesing your information. Please do not leave the page.')}/> /* THIS LOADER SHOULD APPEAR ONLY WHEN STRIPE PROCCESES THE PAYMENT INFO*/} 
  
        <CheckoutExtraInput>
            <PhoneContext.Provider value={{ phoneCode, setPhoneCode }}>
              <Builder_ title={t('Fill in your phone number')} >
                  <Input_Phone_Register
                      placeholder={t('Phone number')}
                      listIcon="Phone"
                      errors={messages.errorsPhone}
                      helpers={messages.helpersPhone}
                      successes={messages.successesPhone}
                      onChange={validatePhoneFormat}
                      value={currentPhone}
                      required
                  />
              </Builder_>
            </PhoneContext.Provider>
            <Builder_ title={t('Country')}>
              <Dropdown_>
                  <select defaultValue={'Greece'}  value={props?.selectedCountry} onChange={(e) => props?.setSelectedCountry(e.target.value)}>
                  {monicaCountries.map((country, i) => (
                      <option key={i} value={country?.code}>
                      {country?.flag} {country.country}
                      </option>
                  ))}
                  </select>
              </Dropdown_>
            </Builder_>
            <Checkbox_
              checked={props?.showVatInput} 
              className="Invoice" 
              text={t("I wish an invoice")} 
              onClick={handleCheckboxChange}
              id='invoiceVat'
            />
  
            {props?.showVatInput ? <Builder_>
              <Input_ 
                placeholder={t("Taxpayer Identification Number (ΤΙΝ)")} 
                onChange={(e)=>checkTin(e.target.value, true)} 
                helpers={messages?.helpersVat} 
                successes={messages?.successesVat} 
                errors={messages?.errorsVat} 
                value={vatInput}
                required
              />
            </Builder_> : null}
  
        </CheckoutExtraInput>
        {canReuseSavedPaymentMethod ? (
          <SavedPaymentMethod>
            <SavedPaymentMethodDetails>
              <strong>{t("Saved card")}</strong>
              <p>{savedPaymentMethod.brand} {t("ending in")} {savedPaymentMethod.last4} · {t("expires")} {savedPaymentMethod.expMonth}/{savedPaymentMethod.expYear}</p>
            </SavedPaymentMethodDetails>
            <SavedPaymentMethodActions>
              <SavedPaymentMethodSelection>{t("Use this card")}</SavedPaymentMethodSelection>
              <Grey_ size="small" text={t("Use another card")} onClick={() => setUseSavedPaymentMethod(false)} />
            </SavedPaymentMethodActions>
          </SavedPaymentMethod>
        ) : null}
        {!isReusingSavedPaymentMethod ? (
          <PaymentElement options={{defaultValues:{address:{country:props?.selectedCountry}},fields:{name:"never", email:"never", billingDetails:{address:"never"}}}}/>
        ) : null}
        <Actions_>
          <Grey_ size="large" text={t("Back")} iconLeft="Back" onClick={()=>navigate(-1)}/>
          <Focus_ size="large" text={buttonText} disabled={!stripe || loading} iconRight="Rocket" onClick={(e) => handleSubmit(e)} />
      </Actions_>
      </PaymentDetails>
    );
  }
  
